module.exports = __webpack_public_path__ + "img/event.ac77f3b1.png";